import { Box, styled } from '@mui/material';

export const PastApptTitle = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  fontWeight: 500,
  alignItems: 'center'
});
